module.exports = __webpack_public_path__ + "static/media/Legs.ecb3b573.jpeg";